<script lang="ts">
    import { getContext } from "svelte";

    import type { Writable } from "svelte/store";
    import type { State } from "../../types/state";

    let state: Writable<State> = getContext("playerState");
    $: visible = ["waiting", "seeking"].includes($state.playerState);
</script>

<div class="loader" class:visible>
    <div class="sk-cube-grid">
        <div class="sk-cube sk-cube1" />
        <div class="sk-cube sk-cube2" />
        <div class="sk-cube sk-cube3" />
        <div class="sk-cube sk-cube4" />
        <div class="sk-cube sk-cube5" />
        <div class="sk-cube sk-cube6" />
        <div class="sk-cube sk-cube7" />
        <div class="sk-cube sk-cube8" />
        <div class="sk-cube sk-cube9" />
    </div>
</div>

<style lang="scss">
    .loader {
        width: 100%;
        height: 100%;
        display: none;
        align-content: center;
        align-items: center;
        justify-content: space-around;
        position: absolute;
        top: 0;

        &.visible {
            display: flex;
        }

        .sk-cube-grid {
            width: 60px;
            height: 60px;

            .sk-cube {
                width: 33%;
                height: 33%;
                background-color: rgb(255, 255, 255);
                float: left;
                -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite
                    ease-in-out;
                animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
            }
            .sk-cube1 {
                -webkit-animation-delay: 0.2s;
                animation-delay: 0.2s;
            }
            .sk-cube2 {
                -webkit-animation-delay: 0.3s;
                animation-delay: 0.3s;
            }
            .sk-cube3 {
                -webkit-animation-delay: 0.4s;
                animation-delay: 0.4s;
            }
            .sk-cube4 {
                -webkit-animation-delay: 0.1s;
                animation-delay: 0.1s;
            }
            .sk-cube5 {
                -webkit-animation-delay: 0.2s;
                animation-delay: 0.2s;
            }
            .sk-cube6 {
                -webkit-animation-delay: 0.3s;
                animation-delay: 0.3s;
            }
            .sk-cube7 {
                -webkit-animation-delay: 0s;
                animation-delay: 0s;
            }
            .sk-cube8 {
                -webkit-animation-delay: 0.1s;
                animation-delay: 0.1s;
            }
            .sk-cube9 {
                -webkit-animation-delay: 0.2s;
                animation-delay: 0.2s;
            }
        }

        @-webkit-keyframes sk-cubeGridScaleDelay {
            0%,
            70%,
            100% {
                -webkit-transform: scale3D(1, 1, 1);
                transform: scale3D(1, 1, 1);
            }
            35% {
                -webkit-transform: scale3D(0, 0, 1);
                transform: scale3D(0, 0, 1);
            }
        }

        @keyframes sk-cubeGridScaleDelay {
            0%,
            70%,
            100% {
                -webkit-transform: scale3D(1, 1, 1);
                transform: scale3D(1, 1, 1);
            }
            35% {
                -webkit-transform: scale3D(0, 0, 1);
                transform: scale3D(0, 0, 1);
            }
        }
    }
</style>
